import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { ShieldCheck } from 'lucide-react';
import { TaxIdFields, isValidTin } from './TaxIdFields';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const TaxIdPrompt = ({ token, onDone }) => {
  const [type, setType] = useState('ssn');
  const [value, setValue] = useState('');
  const [busy, setBusy] = useState(false);

  const submit = async () => {
    if (!isValidTin(value)) return toast.error('Enter all 9 digits');
    setBusy(true);
    try {
      await axios.put(`${API}/pas-auth/tax-id`, { tax_id: value, tax_id_type: type }, { headers: { Authorization: `Bearer ${token}` } });
      toast.success('Tax ID saved. Your Form 8824s are now filled in with it.');
      onDone();
    } catch (err) { toast.error(err.response?.data?.detail || 'Could not save'); }
    finally { setBusy(false); }
  };

  return (
    <div className="fixed inset-0 bg-black/70 backdrop-blur-sm z-50 flex items-center justify-center p-4" data-testid="tax-id-prompt">
      <div className="bg-slate-800 border border-slate-700 rounded-2xl p-6 w-full max-w-md">
        <div className="flex items-center gap-3 mb-2">
          <ShieldCheck className="w-6 h-6 text-emerald-400" />
          <h2 className="text-lg font-bold text-white">Add your SSN or EIN</h2>
        </div>
        <p className="text-sm text-slate-400 mb-5">We need it once to fill in the identifying number on every IRS Form 8824 for your BETH transactions.</p>
        <TaxIdFields type={type} value={value} onType={setType} onValue={setValue} testPrefix="tax-id-prompt" />
        <button onClick={submit} disabled={busy} data-testid="tax-id-prompt-save"
          className="w-full mt-5 bg-emerald-500 hover:bg-emerald-600 text-white rounded-lg py-3 font-semibold disabled:opacity-50">{busy ? 'Saving...' : 'Save Tax ID'}</button>
      </div>
    </div>
  );
};
